<template>
  <select class="form-control" :required="true" v-model="selected" :disabled="disabled" @change="la_schimb">
   <option v-for="(option, index) in options" v-bind:key="index" v-bind:value="option">{{ option }}</option>
  </select>
</template>

<script>
export default {
    name: 'FSelect',
    data () {
        return {
        selected: "Favorite",
        }
    },
    props: {
        options: { type: Array, default: () => [] },
        initial: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
    },
    methods:{
        la_schimb: function(){
            this.$emit('fselect', [this.selected,])
        }
           
    },
    mounted(){
        this.$emit('fselect', [this.initial,])
        this.selected = this.initial
    }
    

}
</script>
